import React from 'react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, GUARANTEE_LINE, PRODUCT_IMG, RATING_LINE } from './constants';
export function FinalCTA() {
  return <section className="bg-petrol px-4 py-8 text-cream" data-id="element-46" data-mp="3ueqf77ukevdj">
      <div className="mx-auto max-w-2xl text-center" data-id="element-47" data-mp="c7k43tn1wfmr">
        <p className="font-display text-[11px] font-bold uppercase tracking-[0.14em] text-mustard sm:text-xs" data-id="element-48" data-mp="85fdl3rwfz4c">
          Un'ultima occasione
        </p>
        <div className="mt-2 space-y-1 text-[15px] leading-snug text-cream/90 sm:text-base" data-id="element-49" data-mp="m3dry967zvju">
          <p data-id="element-50" data-mp="h5c8hn4vtu7u">
            La tua esperienza professionale dovrebbe essere dedicata al paziente, non a ricostruire
            continuamente materiale che potresti avere già organizzato.
          </p>
          <p data-id="element-51" data-mp="qw6vwutv6zuv">Smetti di perdere ore tra PDF, cartelle, schede, appunti e documenti sparsi.</p>
          <p data-id="element-52" data-mp="14w7xydlv8dbx">Smetti di partire da zero per ogni nuova sessione.</p>
          <p data-id="element-53" data-mp="zwv9xpj9d07r">
            Inizia a lavorare con un sistema professionale che riunisce pianificazione, attività,
            sessioni, progressioni, monitoraggio e materiali pronti all'uso.
          </p>
          <p data-id="element-54" data-mp="2h37x6x1xaiyk">
            Con LOGOPEDIA PRO™ avrai finalmente un'unica struttura da cui partire per organizzare il
            tuo lavoro in modo più rapido, coerente e professionale.
          </p>
        </div>

        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="mt-4 block rounded-2xl bg-cream p-4" data-id="element-55" data-mp="2r2ysh0yb51zp">
          <img src={PRODUCT_IMG} alt="LOGOPEDIA PRO™ con i 6 moduli e i 5 bonus esclusivi" className="mx-auto w-full max-w-xs transition-transform duration-200 ease-out hover:scale-[1.01]" data-id="element-56" data-mp="302c3hy22xymj" />
          <h2 className="mt-2 font-display text-xl font-black uppercase leading-tight sm:text-2xl" data-id="element-57" data-mp="39r3r5u03xwrn">
            🗣️ LOGOPEDIA PRO™
          </h2>
          <p className="mt-0.5 font-display text-[13px] font-semibold uppercase text-petrol sm:text-sm" data-id="element-58" data-mp="3epova4ihd0ld">
            Sistema Professionale Completo 6-in-1 + 5 Bonus Esclusivi
          </p>
          <p className="mt-2 text-sm text-graphite" data-id="element-59" data-mp="1jm8tbts2bwv7">
            Prezzo di Listino: <span className="line-through" data-id="element-60" data-mp="1eqtk5f502p54">97€</span>
          </p>
          <p className="font-display text-3xl font-black leading-none text-petrol sm:text-4xl" data-id="element-61" data-mp="1sh6oz8mlhnq8">
            Oggi Solo: 27€
          </p>
        </a>

        <CTAButton href={CHECKOUT_URL} className="mt-3" data-id="element-62" data-mp="1nonbscrtkuly" />
        <p className="mt-2 text-[13px] font-semibold text-mustard" data-id="element-63" data-mp="22e1mppb1nk3g">
          Accesso Immediato • Consegna Istantanea via Email
        </p>
        <p className="mt-1 text-[13px] text-cream/90" data-id="element-64" data-mp="1xfhytjcw3y8g">{RATING_LINE}</p>
        <p className="text-[13px] text-cream/90" data-id="element-65" data-mp="2be7zta2tyi23">{GUARANTEE_LINE}</p>
      </div>
    </section>;
}